import React from 'react';
import TextTransformation from '../../utils/textTransformation';

const formatMealItemPrice = (mealItemPrice) => {
  const value = Number(mealItemPrice);
  if (!Number.isFinite(value)) {
    return 'Meal item';
  }

  return `$${value.toFixed(2)}`;
};

const MealItemNamesSection = ({ order }) => {
  const mealItems = Array.isArray(order?.meal_item_names) ? order.meal_item_names : [];

  if (!mealItems.length) {
    return null;
  }

  return (
    <section className='action-order-detail__section'>
      <h3 className='action-order-detail__section-title'>
        Meal item{mealItems.length > 1 ? 's' : ''}
      </h3>
      <div className='action-order-detail__items-list'>
        {mealItems.map((item, index) => (
          <div className='action-order-detail__item' key={`${item?.item}_${index}`}>
            <div className='action-order-detail__item-row'>
              <span className='action-order-detail__qty'>{item.qty ?? 1}</span>
              <div className='action-order-detail__item-body'>
                <div className='action-order-detail__item-name'>{item.item}</div>
                {item?.promotion && (
                  <div className='action-order-detail__item-promo'>
                    Applied -{' '}
                    <span className='action-order-detail__item-promo-label'>
                      {TextTransformation(item.promotion)}
                    </span>
                  </div>
                )}
                {item?.product_category && (
                  <div className='action-order-detail__item-tag'>
                    {TextTransformation(item.product_category)}
                  </div>
                )}
              </div>
              <div className='action-order-detail__item-price'>
                {formatMealItemPrice(item.mealItemPrice)}
              </div>
            </div>
            {item?.extra_toppings?.length > 0 && (
              <div className='action-order-detail__topping-list'>
                {item.extra_toppings.map((t) => (
                  <div className='action-order-detail__topping-row' key={t.topping_name}>
                    <span className='action-order-detail__topping-name'>
                      {`${t.topping_name} (${t.topping_qty})`}
                    </span>
                    <span className='action-order-detail__topping-price'>
                      ${(t.topping_qty * t.price).toFixed(2)}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default MealItemNamesSection;
